import React from 'react';
import { Item } from './types';
import { getCurrencyNameOrSymbol } from '../../../../utils/currency';
import { prependLocaleToPath } from 'src/scripts/utils/localization';
import { checkIfProductIsRewardOrGWP } from 'src/scripts/templates/product/utils';
import { formatAmount } from './helpers';

const LineItem = ({
  item,
  returnExchangeCopy,
  orderShippingCountryCode,
}: {
  item: Item;
  returnExchangeCopy: string | null | undefined;
  orderShippingCountryCode: string;
}) => {
  const lowerCasedTags = item.tags?.map((tag) => tag.toLowerCase()) || [];
  const isGiftOrReward = checkIfProductIsRewardOrGWP(lowerCasedTags);
  const amount = Number(item.price_paid.amount);
  const itemPrice =
    amount === 0
      ? 'FREE'
      : `${getCurrencyNameOrSymbol(item.price_paid.currency_code, 'narrowSymbol')}${formatAmount(
          amount,
          orderShippingCountryCode,
          false
        )}`;
  const selectedColor = item.selected_options.find((option) => option.name.toLowerCase() === 'color');
  const selectedSize = item.selected_options.find((option) => option.name.toLowerCase() === 'size');

  return (
    <div className="line-item-wrapper">
      <div className="mobile-title d-md-none d-flex justify-content-between">
        <p className="body semibold">{item.product_title}</p>
        <div className="line-item-price body semibold">{itemPrice}</div>
      </div>
      <div className="line-item">
        <div className="line-item-info">
          <img
            src={item.image_url || '/cdn/shop/files/Missing_Image_200x.png?v=8684511414166916069'}
            alt={item.product_title}
            width={100}
          />
          <div className="info">
            <div className="top-part">
              <p className="body semibold d-none d-md-block">{item.product_title}</p>
              {returnExchangeCopy && <p className="return-status body-small d-none d-md-block">{returnExchangeCopy}</p>}
              {item.return_suggestion && (
                <p className="final-sale d-none d-md-block">{item.return_suggestion.toUpperCase()}</p>
              )}
            </div>
            <div className="bottom-part d-none d-md-block">
              {item.availability_status_message && !isGiftOrReward ? (
                <p className="body">
                  {item.availability_status_message}{' '}
                  <a href={getSearchURL(item.product_title)}>
                    <u>Find more {item.product_title.split(' - ')[0]}</u>
                  </a>
                </p>
              ) : !isGiftOrReward ? (
                <>
                  <a href={prependLocaleToPath(`/products/${item.handle}`)} className="body-small">
                    <span className="body-small underline">Buy it Again</span>
                  </a>
                  {item.shop_all_color_url && selectedColor ? (
                    <a href={prependLocaleToPath(item.shop_all_color_url)} className="body-small">
                      <span> | </span>
                      <span className="body-small underline">Shop All {selectedColor.value}</span>
                    </a>
                  ) : null}
                </>
              ) : null}
            </div>
          </div>
        </div>
        <div className="line-item-variant-info">
          {selectedColor && (
            <p className="body">
              Color: <span className="body semibold">{selectedColor.value}</span>
            </p>
          )}
          {selectedSize && (
            <p className="body">
              Size: <span className="body semibold">{selectedSize.value}</span>
            </p>
          )}
          <p className="body">
            Quantity: <span className="body semibold">{item.quantity}</span>
          </p>
        </div>
        <div className="line-item-price body semibold d-none d-md-block">{itemPrice}</div>
      </div>
      {returnExchangeCopy && <p className="return-status body-small d-md-none mt-2">{returnExchangeCopy}</p>}
      {item.return_suggestion && <p className="final-sale d-md-none">{item.return_suggestion.toUpperCase()}</p>}
      <div className="bottom-part d-md-none mt-2">
        {item.availability_status_message && !isGiftOrReward ? (
          <p className="body">
            {item.availability_status_message}{' '}
            <a href={getSearchURL(item.product_title)}>
              <u>Find more {item.product_title.split(' - ')[0]}</u>
            </a>
          </p>
        ) : !isGiftOrReward ? (
          <>
            <a href={prependLocaleToPath(`/products/${item.handle}`)} className="body-small">
              <span className="body-small underline">Buy it Again</span>
            </a>
            {item.shop_all_color_url && selectedColor ? (
              <a href={prependLocaleToPath(item.shop_all_color_url)} className="body-small">
                <span> | </span>
                <span className="body-small underline">Shop All {selectedColor.value}</span>
              </a>
            ) : null}
          </>
        ) : null}
      </div>
    </div>
  );
};

export default LineItem;

const getSearchURL = (title: string) => {
  return prependLocaleToPath(`/search?q=${title.replace(' - ', ' ').trim().split(' ').join('+')}`);
};
